<template>
  <div class="container-fluid py-4">
    <div class="row">
      <div class="col-lg-12 col-12">
        <div class="row">
          <div class="d-flex row flex-row">
            <!-- <div class="d-flex flex-row"> -->
            <div class="col-sm-5">
              <input
                type="text"
                class="form-control"
                id="exampleInputEmail1"
                aria-describedby="emailHelp"
                placeholder="Buscar por asunto, mensaje, fecha, destinatario"
                v-model="valueSearch"
                @keyup.enter="getMessages"
              />
            </div>
            <div class="col-sm-3">
              <button
                type="button"
                class="btn bg-gradient-dark null null"
                @click="getMessages()"
                style="margin-left: 10px"
              >Buscar</button>
            </div>
            <!-- </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <Table :columns="columns" listType="seen" :messages="messages" :pagination="pagination"></Table>
      </div>
    </div>
  </div>
</template>

<script>
import Table from "./components/Table.vue";
import axios from "axios";

export default {
  name: "ListMessages",
  components: {
    Table,
  },
  data() {
    return {
      messages: [],
      listType: "RECEIVE",
      isDisabled: false,
      pagination: null,
      columns: [
        {
          name: "Enviado por",
          field: "sender_name",
        },
        {
          name: "Enviado a",
          field: "participants",
        },
        {
          name: "Asunto",
          field: "subject",
        },
        {
          name: "Tipo",
          field: "type_received",
        },
        {
          name: "Privacidad",
          field: "privacity",
        },
        {
          name: "Tipo de mensaje",
          field: "type_message_value",
        },
        {
          name: "Fecha",
          field: "created_at",
        },
      ],
      valueSearch: null,
    };
  },
  watch: {
    listType(newValue, oldValue) {
      this.getMessages(newValue);
    },
    valueSearch(newVal) {
      if (newVal == "") {
        this.valueSearch = null;
        this.getMessages()
      }
    },
  },
  methods: {
    async getMessages(page = 1) {
      this.isDisabled = true;
      const { status, data: dataA } = await axios.post(
        `${process.env.VUE_APP_API_BOOKAPP}messages/${this.valueSearch}?page=${page}`,
        { type: "VIEWED" },
        {
          headers: {
            Authorization: localStorage.getItem("token_bookapp"),
            conexion: localStorage.getItem("conexion"),
          },
        }
      );
      if (status == 200) {
        this.messages = dataA.data;
        const { data, meta,...resto } = dataA;
        this.pagination = meta;

        this.messages.map((m) => {
          // m.sender_name = `${m.sender.name} ${m.sender.lastname}`;
           m.participants = m.participants.slice(0, 40);
          const div = document.createElement("div");
          div.innerHTML = m.message;
          // m.message_no_html = div.textContent || div.innerText || "";
          // m.message_no_html = m.message_no_html.slice(0, 50);
           m.status =
            m.status == "seen" ? "Visto" : "Sin leer";

            m.type_message_value = m.type_message.name;

            m.privacity = m.privacity == 'private'?'privado':'publico';
            
            
        });
        // this.messages.reverse();
      } else {
        console.log("Hubo un error coonsultando los tipos de mensaje");
      }
      this.isDisabled = false;
    },
    async changePage(page) {
      this.getMessages(page);
    },
  },
  mounted() {
    this.getMessages(1);
  },
};
</script>
